"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// fetch our configuration of core entities
const global_1 = require("./../global");
const i0 = require("@angular/core");
class UiStateEngineFeature {
    constructor(id, obj) {
        this.schema = ['id', 'title', 'showCount', 'allowed', 'menu', 'icon', 'router', 'onclick', 'tooltip', 'showOptionIn', 'showContentIn'];
        this.id = null;
        this.title = null;
        this.showCount = null;
        this.allowed = false;
        this.icon = null;
        this.router = null;
        this.onclick = null;
        this.menu = null;
        this.tooltip = null;
        this.showOptionIn = null;
        this.showContentIn = null;
        this.id = id;
        this.schema.forEach(item => {
            if (obj[item]) {
                this[item] = obj[item];
            }
        });
    }
}
exports.UiStateEngineFeature = UiStateEngineFeature;
class UiStateEngine {
    constructor() {
        // list our widgets
        this.widgets = new Map();
        // list our features
        this.features = new Map();
        // list of where the features are to be shown
        this.show = new Map();
        // current mode
        this.currentMode = null;
        // model state
        this.modelDirty = true;
        // cache of data
        this.cache = new Map();
        // console.log ( 'state engine started' );
        this.addWidgets(global_1.UiStateMachineConfig.widgets);
    }
    reset() {
        // clear the cache and the features (widgets stay put)
        this.cache.clear();
        this.features.clear();
    }
    addWidgets(inp) {
        inp.forEach(element => {
            this.addWidget(element['id'], inp);
        }, true);
    }
    addWidget(widget_id, inp) {
        this.widgets.set(widget_id, inp);
    }
    // get a list of features of a widget
    getWidget(widget_id) {
        let result = null;
        // if it's been asked for before, return a cached version
        if (result = this.cache.get(widget_id)) {
            // console.log ( 'state returning ['+widget_id+'] (cached)', result);
            return result;
        }
        // no cache? Let's create a new one
        let ret = [];
        // go through all features
        for (const [f_id, f] of this.features.entries()) {
            // show in our widget?
            if (f.showOptionIn && f.showOptionIn == widget_id) {
                ret.push(f);
            }
        }
        // save to the cache for future uses
        this.cache.set(widget_id, ret);
        return ret;
    }
    addFeature(feature_id, inp) {
        // console.log ( 'add: '+feature_id, typeof inp['allowed'], inp['allowed'], inp.hasOwnProperty('allowed') );
        // if no allow input, then default is to allow
        if (!inp.hasOwnProperty('allowed')) {
            inp['allowed'] = true;
        }
        // is it allowed?
        if (inp['allowed']) {
            // add it
            this.features.set(feature_id, new UiStateEngineFeature(feature_id, inp));
        }
    }
    getCurrentMode() {
        return this.currentMode;
    }
}
UiStateEngine.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UiStateEngine_Factory() { return new UiStateEngine(); }, token: UiStateEngine, providedIn: "root" });
exports.UiStateEngine = UiStateEngine;
